import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import StatusBadge from '@/components/StatusBadge';
import { formatDate, formatGBP, shortId } from '@/lib/utils';

export const PAYMENT_STATUSES = ['unpaid', 'pending', 'paid', 'failed', 'refunded'];

export default function PaymentRow({ payment }) {
  return (
    <TableRow data-testid={`payment-row-${payment.id}`}>
      <TableCell className="font-mono text-xs">{shortId(payment.id)}</TableCell>
      <TableCell className="font-mono text-xs">{shortId(payment.booking_id)}</TableCell>
      <TableCell className="font-mono text-xs text-slate-600">
        {payment.stripe_payment_intent_id || '—'}
      </TableCell>
      <TableCell className="font-semibold text-slate-900">{formatGBP(payment.total_amount)}</TableCell>
      <TableCell className="text-rose-700">{formatGBP(payment.platform_commission)}</TableCell>
      <TableCell className="text-emerald-700">{formatGBP(payment.partner_payout)}</TableCell>
      <TableCell><StatusBadge value={payment.status} /></TableCell>
      <TableCell className="text-xs text-slate-500">{formatDate(payment.created_at)}</TableCell>
    </TableRow>
  );
}
